
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"5.18848","y":"13.1621","width":"11.5867","height":"2.10667","rx":"1.05333","transform":"rotate(-45 5.18848 13.1621)","fill":"#D9DDE4"}}),_c('path',{attrs:{"d":"M5.88777 7.47795L12.1817 7.65846L12.3623 13.9523C12.3606 14.5157 12.8159 14.9731 13.3792 14.9741C13.9426 14.9751 14.4006 14.5191 14.4023 13.9559L14.4251 6.43553C14.4259 5.87116 13.9658 5.41418 13.4032 5.41514L5.88419 5.43794C5.3209 5.43966 4.86498 5.89767 4.866 6.46103C4.86699 7.02435 5.32444 7.47963 5.88777 7.47795Z","fill":"#D9DDE4"}})])
          )
        }
      }
    